/** Insert partway through a pipe function to log the inputs and outputs */
export const trace =
  <T, X>(message: string, func: (i: T) => X) =>
  (input: T): X => {
    const output = func(input);
    console.log(message + ' Input: ', input);
    console.log(message + ' Output: ', output);
    return output;
  };
